import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { IPaquete } from '@appNeo/core/interfaces/IPaquete';
import { TipoPaginadorEnum } from '@appNeo/neoShared/helpers/enums/TipoPaginador.enum';
import { IRespApi } from '@appNeo/neoShared/helpers/interfaces/IResp-api';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { Paginator } from '@appNeo/neoShared/models/paginator/paginator';
import { environment } from '@environments/environment';
import { BehaviorSubject, Subject, Observable, map, catchError, forkJoin, throwError, tap, of } from 'rxjs';
import { EXTRAIMGPRINCIPAL } from '@appNeo/admin/configuracion/datos-estaticos-demo';
import { IExtra } from '@appNeo/core/interfaces/IExtra';
import { UtilidadesLayoutService } from '@appNeo/neoShared/services/utilidades/utilidades-layout.service';
import { BYPASS_SIN_TOKEN } from '@appNeo/neoCore/interceptors/jwt/jwt.interceptor';
import { LOADER_TRANSPARENT } from '@appNeo/neoCore/interceptors/loaderInterceptor/loader.interceptor';
import { IDIOMA_DEFECTO } from '@appNeo/core/global';

@Injectable({
  providedIn: 'root'
})
export class PaquetesService {
  // getAll
  // get
  // create
  // update
  // resolve
  // getImagenes
  // getExtras
  // establecerExtras

  contextoSinToken = { context: new HttpContext().set(BYPASS_SIN_TOKEN, true) };
  public editando$ = new BehaviorSubject<boolean>(false);

  urlEntidad = environment.api_url + '/paquetes';
  contextLoaderTransparent = { context: new HttpContext().set(LOADER_TRANSPARENT, true) };

  public error422Api$: Subject<IRespApi> = new Subject<IRespApi>();
  public paquete$: BehaviorSubject<IPaquete> = new BehaviorSubject<IPaquete>(null);
  public paquetes$: BehaviorSubject<IPaquete[]> = new BehaviorSubject<IPaquete[]>(null);
  public totalpaquetes$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  constructor(
    private http: HttpClient,
    private auxiliar: AuxiliarService,
    private utilidadesLayoutService: UtilidadesLayoutService
  ) { }

  set entidad(paquete: IPaquete) {
    let paqueteMap = { ...paquete };
    if (paqueteMap?.id) {
      this.paquete$.next(paqueteMap);
    } else {
      if (this.paquete$.value !== undefined) {
        this.paquete$.next(undefined);
      }
    }

  }



  set editando(flag: boolean) {
    this.editando$.next(flag);
  }

  getAll(tipoPaginador?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<IPaquete[]> {
    if (!filtros || Object.keys(filtros).length <= 0) {
      filtros = this.auxiliar.filtrosDefectoOrden();
    }
    let request = (tipoPaginador === TipoPaginadorEnum.offline)
      ? this.urlEntidad
      : `${this.urlEntidad}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`;
    return this.http.get(request, { ...this.contextoSinToken }).pipe(
      // tap( (data: IRespApi )=> console.log('Debug data extras', data)),
      tap((data: IRespApi) => this.totalpaquetes$.next(data.total)),
      tap((data: IRespApi) => this.paquetes$.next(this.mapearEntidades(data.data))),
      map((data: IRespApi) => this.mapearEntidades(data.data)),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestGetAllPaquetes');
      })
    );
  }

  get(id): Observable<IPaquete> {
    return this.http.get(`${this.urlEntidad}/${id}`, { ...this.contextoSinToken }).pipe(
      map((data: IRespApi) => this.mapearEntidad(data['data'])),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestGetPaquete');
      })
    );
  }

  getExtrasAsociados(idPaquete): Observable<object[]> {
    return this.http.get(`${this.urlEntidad}/${idPaquete}/extras`, { ...this.contextLoaderTransparent }).pipe(
      map((data: IRespApi) => this.mapearExtraAsociado(data.data)),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestGetPaquete');
      })
    );
  }

  mapearExtraAsociado(extras): object[] {
    // console.log('Recibimos extras', extras);
    let idExtrasAsociados: object[] = [];
    if (extras.length) {
      extras.forEach((element, index) => {
        if (element['extra']) {
          let camposTraduccion = {};
          if (element.extra.idiomas) {
            camposTraduccion = this.auxiliar.obtenerContenidoPorIdioma(element.extra.idiomas);
          }
          idExtrasAsociados.push({ ...element, extra: { ...element.extra, ...camposTraduccion }, id: element['idExtra'], obligatorio: element['obligatorio'] });

        }
      });
      return idExtrasAsociados;
    }
  }


  mapearEntidades(paquetes: IPaquete[]) {
    if (paquetes.length) {
      paquetes.forEach((element, index) => {
        paquetes[index] = this.mapearEntidad(element);
      });

    }
    return paquetes;
  }

  mapearEntidad(entidad: IPaquete): IPaquete {
    // let fechaFormatt = new Date(item?.fecha);
    // let fechaFormatt = this.datepipe.transform(item?.fecha, 'dd/MM/yyyy');
    // let importeFormatt = item.importe.toFixed(2);
    let item = Object.assign({}, entidad);
    if (item['activo']) {
      item['activo'] = this.auxiliar.getBoolean(item['activo']);
    }
    if (item['turnos'].length > 0) {
      item['turnos'].map(turno => {
        if (typeof turno['hora'] === 'string' || turno['hora'] instanceof String) {
          turno['hora'] = this.auxiliar.conversionStringHora(turno['hora']);
        }
      })
    }

    item['extras'].map((extraPaquete, posicion, extrasArray) => {
      let camposTraduccionExtras = {};
      if (extraPaquete.idiomas) {
        camposTraduccionExtras = this.auxiliar.obtenerContenidoPorIdioma(extraPaquete.idiomas);
      }
      // console.log('Extra con idioma en raiz ', { ...extraPaquete, ...camposTraduccionExtras });
      let valor = { valor: camposTraduccionExtras['nombre'] };
      item['extras'][posicion] = { ...extraPaquete, ...valor, ...camposTraduccionExtras };
    })
    if (item['extras'].length > 0 && item['extras'][0]['idExtra']) {
      let extrasNombre = [];
      item.extras.forEach(extra => {
        extrasNombre.push(extra.nombre);
        item.extrasReducido = extrasNombre;
      })
    }
    let camposTraduccion = {};
    if (item.idiomas) {
      camposTraduccion = this.auxiliar.obtenerContenidoPorIdioma(item.idiomas);
    }
    let _item = { ...item, ...camposTraduccion };

    let ficheroDestacado;
    if (_item?.ficheros.length > 0) {
      ficheroDestacado = this.auxiliar.buscarObjetosArrayByValorAtributo(_item?.ficheros, 'destacado', true)[0];
    }

    let miniaturaListado;
    if (ficheroDestacado) {
      if (ficheroDestacado?.miniaturas && ficheroDestacado?.miniaturas['_mini/listado']) {
        miniaturaListado = ficheroDestacado.miniaturas['_mini/listado'];
      }
    }

    if (miniaturaListado) _item['ruta'] = miniaturaListado;
    return _item;
  }

  create(request: any): Observable<any> {
    return this.http.post<IRespApi>(`${this.urlEntidad}`, request).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostPaquete');
      })
    );
  }

  update(id: string, request: any) {
    return this.http.put(`${this.urlEntidad}/${id}`, request).pipe(
      map((data: IRespApi) => data['data']),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPutPaquete');
      })
    );
  }

  getImagenPrincipal(idExtra: string) {
    // return this.http.get(`${his.urlEntidad}imagenPrincipal/${idExtra}`).pipe(
    //   map((data: IRespApi) => data));
    return new Observable<any>(observer => {
      observer.next(EXTRAIMGPRINCIPAL);
      observer.complete();
    });
  }
  eliminarImagenPrincipal(idExtra: string) {
    return this.http.delete(`${this.urlEntidad}imagenPrincipal/${idExtra}`).pipe(
      map((data: IRespApi) => data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestDeleteImagenPrincipalPaquete');
      })
    );
  }
  editarImagenPrincipal(idExtra: string, request: any) {
    return this.http.put(`${this.urlEntidad}imagenPrincipal/${idExtra}`, request).pipe(
      map((data: IRespApi) => data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequesPutImagenPrincipalPaquete');
      })
    );
  }

  subirFicheros(idPaquete: string, request: any) {
    return this.http.post<IRespApi>(`${this.urlEntidad}/${idPaquete}/ficheros`, request).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostPaqueteFichero');
      })
    );
  }
  editarFichero(idFichero: string, request: any) {
    return this.http.patch<IRespApi>(`${this.urlEntidad}/${idFichero}/ficheros`, request).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestEditarPaqueteFichero');
      })
    );
  }
  eliminarFichero(idFichero: string) {
    return this.http.delete(`${this.urlEntidad}/${idFichero}/ficheros`).pipe(
      map((valor: string) => this.auxiliar.getBoolean(valor)),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestDeletePaqueteFichero');
      })
    );
  }


  asignarExtrasPaquete(idPaquete: string, request: any) {
    return this.http.post<IRespApi>(`${this.urlEntidad}/${idPaquete}/asignarExtras`, request).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostExtrasPaquete');
      })
    );
  }

  // TODO: pendiente endpoint back
  // asignarPrecioExtraxPaquete(idPaquete: string, request: any) {
  //   return this.http.post<IRespApi>( `${this.urlEntidad}/${idPaquete}/asignarPrecioExtraxPaquete`, request ) .pipe(
  //     map( (resp: IRespApi) => resp.data),
  //     catchError( (err: IRespApi) => {
  //       return this.handleError( err,  'IRequestPostExtrasPaquete');
  //     })
  //   );
  // }

  vaciarExtrasPaquete(idPaquete: string) {
    return this.http.post<IRespApi>(`${this.urlEntidad}/${idPaquete}/eliminarExtras`, {}).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostVaciarExtrasPaquete');
      })
    );
  }


  asignarTurnos(idPaquete: string, request: any) {
    return this.http.post<IRespApi>(`${this.urlEntidad}/${idPaquete}/asignarTurnos`, request).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostAsignarTurnos');
      })
    );
  }

  eliminarTurnos(idPaquete: string) {
    return this.http.post<IRespApi>(`${this.urlEntidad}/${idPaquete}/eliminarTurnos`, {}).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostEliminarTurnos');
      })
    );
  }

  getConfiguracionFicheros(clave: string) {
    return this.http.get(`${this.urlEntidad}/configuracionFicheros/${clave}`).pipe(
      map((data: IRespApi) => this.utilidadesLayoutService.getConfiguracionFichero(data['data']))
    );
  }

  obtenerConfiguracionCamposMultimedia() {
    let peticion = {
      tamanoMaximoFichero: this.getConfiguracionFicheros('ficheros_maxTamanoFichero'),
      formatosPermitidos: this.getConfiguracionFicheros('ficheros_formatos'),
    };
    return forkJoin(peticion);
  }

  /************************************
  * Funciones apoyo                  *
  *************************************/
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {

    let peticion = {
      listadoEntidad: this.getAll(undefined, undefined, { activo: 1, idIdioma: IDIOMA_DEFECTO, order: 'id', tipoOrden: 'asc' }).pipe(
        catchError(err => of(err))
      ),
      // configuracionFicheros: this.obtenerConfiguracionCamposMultimedia(),
    };

    //  console.log(route.url, 'RESOLVER PAQUETE ');
    const id = route.params.id;
    if (id) {
      peticion['entidad'] = this.get(id).pipe(
        catchError(err => of(err))
      );
    }

    return forkJoin(peticion);
  }

  public handleError(err: any, idRequest?: string): Observable<never> {
   // Casos especiales: errores no estándar enviados como string
   if (err === 'OK') {
     const mensaje = environment.errorServidorSinCodigo;
     return this.lanzarError(err, mensaje);
   }
 
   if (err === 'Unknown Error') {
     const mensaje = environment.errorServidorUnknown;
     return this.lanzarError(err, mensaje);
   }
 
   // Adjuntamos el idRequest como contexto
   err.request = idRequest;
 
   // Error validación (422)
   if (err.codigoError === 422) {
     console.warn('Error 422 recibido por CRUD:', err);
     this.error422Api$.next(err); // Emitimos error personalizado
   }
 
   // Mensaje base
   let mensaje = err?.mensaje || 'Error desconocido';
 
   // Error de permisos (403): agregamos detalles del array `data`
   if (err.codigoError === 403 && Array.isArray(err.data)) {
     const detalles = err.data.map(d => d.mensaje).join(', ');
     mensaje = `${mensaje}: ${detalles}`;
   }
 
   // Error no encontrado (404): manejamos string o array con id 999
   if (err.codigoError === 404 && err.data) {
     if (typeof err.data === 'string') {
       mensaje = `${mensaje}: ${err.data}`;
     } else if (Array.isArray(err.data)) {
       const aviso999 = err.data.find(d => d.id === 999);
       if (aviso999) {
         mensaje = `${mensaje} ${aviso999.mensaje}`;
       }
     }
   }
 
   return this.lanzarError(err, mensaje);
 }
 
 private lanzarError(err: any, mensaje: string): Observable<never> {
   return throwError(() => ({
     error: true,
     data: err?.data,
     mensaje,
     err
   }));
 }
}
